import type { DetailedSelectItem } from '@repo/commons/models'

export const hasUniformElementTypeLabels = (items: readonly DetailedSelectItem[]): boolean => {
	// in the uniform case, no need to show elementType labels
	const firstLabel = items[0]?.label
	return (
		!!firstLabel?.isElementType &&
		items.every((item) => item.label?.isElementType && item.label.text === firstLabel.text)
	)
}

/**
 * Finds a DetailedSelectItem by its ID
 * @param items - Array of DetailedSelectItem objects
 * @param id - The ID to search for
 * @returns The found item or null if not found
 */
export function findItemById(
	items: DetailedSelectItem[],
	id: string | number | null | undefined
): DetailedSelectItem | null {
	if (!id || !items?.length) return null

	return items.find((item) => item.id === id) ?? null
}

/**
 * Finds multiple DetailedSelectItems by their IDs
 * @param items - Array of DetailedSelectItem objects
 * @param ids - Array of IDs to search for
 * @returns Array of found items (excludes items that weren't found)
 */
export function findItemsByIds(
	items: DetailedSelectItem[],
	ids: (string | number)[]
): DetailedSelectItem[] {
	if (!ids?.length || !items?.length) return []

	return items.filter((item) => ids.includes(item.id))
}

export const toDetailedSelectItem = (value: unknown): DetailedSelectItem => ({
	id: String(value),
	title: String(value)
})
